import { makeStyles } from '@mui/styles';
import {
  CcfBox,
  CcfErrorFilledIcon,
  CcfServiceBotIcon,
  CcfTypography,
  useTranslator,
} from '@nice-ccf/ui-controls';
import styles from '../ccf-consumer-card-tickets-tab/ccf-consumer-card-tickets-tab.module.scss';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react';
import { Icon } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfConsumerCardTicketsTabTableProps {
  ticketsData: any;
}

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    '& .MuiDataGrid-root': {
      border: '1px solid rgba(251, 252, 252, 1)',
      // Height: '330px',
      flexGrow: 1,
    },
    '& .MuiDataGrid-cell': {
      fontFamily: 'Open Sans',
      fontSize: '12px',
      lineHeight: '24px',
    },
    '& .MuiDataGrid-row': {
      backgroundColor: '#FFFFFF',
      borderBottom: '1px solid #cbd3d4',
    },

    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526B79',
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      height: '40px',
      background: '#FFFFFF',
      // border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',
      color: '#333333',
    },
    '& .MuiDataGrid-columnHeaders': {
      border: '1px solid #cbd3d4',
    },
    '& .MuiDataGrid-footerContainer': {
      backgroundColor: '#FFFFFF',
      border: '2px solid #d1d9da',
    },
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
      {
        outline: 'none',
      },
    '& .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .custom-bold': {
      fontWeight: 'bold',
    },
    '& .custom-link': {
      color: '#005EB8',
      textDecoration: 'underline',
      cursor: 'pointer',
      pointerEvents: 'auto',
    },
  },
});

/**@example */
export function CcfConsumerCardTicketsTabTable(
  props: CcfConsumerCardTicketsTabTableProps
) {
  const { ticketsData } = props;
  const classes = useStyles();
  const rowsPerPageOptions = [5, 10, 20];
  const [pageSize, setPageSize] = React.useState(rowsPerPageOptions[1]);
  const [translate] = useTranslator();

  /**
   * Used to format contact history date and time
   * @param time -string
   * @example - formatDateTimeHandler()
   */
  const formatDateTimeHandler = (time: string) => {
    const date = new Date(time);

    return date.toLocaleDateString('en-US', {
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const columns = [
    {
      field: 'id',
      headerName: '',
      width: 50,
      // flex: 1,
      renderCell: (params: any) => {
        return (
          <Icon>
            <CcfErrorFilledIcon />
          </Icon>
        );
      },
    },
    {
      field: 'priority',
      headerName: translate('priority'),
      cellClassName: 'custom-bold',
      width: 170,
    },
    {
      field: 'status',
      headerName: translate('status'),
      width: 200,
      renderCell: (params: any) => {
        return (
          <CcfBox
            style={{
              border: '1px solid #005EB8',
              borderRadius: '100px',
              width:'60px',
              textAlign:'center'
            }}
          >
            <CcfTypography style={{ color: '#005EB8',fontSize:'12px' }}>
              {params.value}
            </CcfTypography>
          </CcfBox>
        );
      },
    },
    {
      field: 'agent',
      headerName: translate('Agent'),
      width: 200,
      cellClassName: 'custom-link',
      renderCell: (params: any) => {
        return <span className="pointerEvent">{params.value}</span>;
      },
    },

    {
      field: 'date',
      headerName: translate('Date'),
      width: 200,
      // flex: 1.2,
      renderCell: (params: any) => {
        return (
          <span className="pointerEvent">
            {formatDateTimeHandler(params.value)}
          </span>
        );
      },
    },
    {
      field: 'subject',
      headerName: translate('subject'),
      width: 190,
      // flex: 1.2,
      renderCell: (params: any) => {
        return <span className="pointerEvent">{params.value}</span>;
      },
    },
  ];

  
  return (
    <CcfBox className={styles.tableContainer}>
      <DataGrid
        classes={{ root: classes.root }}
        rows={ticketsData}
        columns={columns}
        rowHeight={40}
        headerHeight={40}
        pageSize={pageSize}
        pagination
        rowsPerPageOptions={rowsPerPageOptions}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        getRowId={(row) => row.id}
        getRowClassName={(params: any) => `styledrows`}
        sx={{
          '& .MuiDataGrid-columnHeaderTitle': {
            color: '#3F5C69',
            fontWeight: '600',
            fontSize: '12px',
            fontFamily: 'Open Sans',
          },
          '& .MuiDataGrid-columnHeader': {
            borderRight: '1px solid #D2D8DB',
          },
          '& .MuiDataGrid-columnHeaders': {
            borderBottom: 'none',
          },
          '& .MuiDataGrid-columnHeader:last-child': {
            borderRight: 'none',
          },
        }}
      />
    </CcfBox>
  );
}

export default CcfConsumerCardTicketsTabTable;
